:host {
  --bar-color: var(--chart-100-pressed);
  --bar-width: 10%; // can also be specified in other units such as px
  --stroke-color: var(--blue-layout-400-primary);
  position: relative;
  height: auto;
}

.progress-ring {
  transform: rotate(-90deg);
  top: 0;
  left: 0;
  overflow: visible;

  &--circle,
  &--circle-bar {
    position: absolute;
    left: 0;
    right: 0;
    stroke-width: var(--bar-width);
    margin: 0 auto;
    transform-origin: 50% 50%;
  }

  &--circle {
    transition: 0.35s stroke-dashoffset;
    stroke: var(--stroke-color);
  }
  &--circle-bar {
    stroke: var(--bar-color);
  }
}
:host([indeterminate]) {
  .progress-ring--circle {
    animation-name: example;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
}
@keyframes example {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

